import './ext.css';
import {modomOptionsManager} from './modom_manager';

const Autodesk = window.Autodesk;
const av = window.av;
//const NOP_VIEWER = window.NOP_VIEWER;

class ModomExtension extends Autodesk.Viewing.Extension {
    load() {
        if (this.viewer.toolbar) {
            this.createUI();
        } else {
            this.viewer.addEventListener(av.TOOLBAR_CREATED_EVENT, this.onToolbarCreated);
        }

        modomOptionsManager.viewer = this.viewer;
        this.viewer.addEventListener(av.GEOMETRY_LOADED_EVENT, this.onGeometryLoaded);
        return true;
    }

    unload() {
        this.viewer.toolbar.removeControl(this._group);
        return true;
    }

    onGeometryLoaded = () => {
        this.viewer.removeEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, this.onGeometryLoaded);
        this.viewer.setGhosting(false);

        // Ensure the action is called when everything is ready
        setTimeout(() => {
            modomOptionsManager.filterModelWithOptions();
            this.viewer.container.classList.add('ready');
        }, 2000);
    };

    onToolbarCreated() {
        this.viewer.removeEventListener(av.TOOLBAR_CREATED_EVENT, this.onToolbarCreated);
        this.createUI();
    }

    createUI() {
        this._group = new Autodesk.Viewing.UI.ControlGroup('modomTools');

        const panelButtons = modomOptionsManager.createPanelUI(
            this.viewer,
            this.viewer.container
        );
        for (const panel of panelButtons) {
            this._group.addControl(panel);
        }

        this._toolbar = new Autodesk.Viewing.UI.ToolBar('modomToolbar');

        this._toolbar.container.style.left = '15px';
        this._toolbar.container.style.top = '0px';

        this._toolbar.addControl(this._group);

        this.viewer.container.appendChild(this._toolbar.container);
    }
}


Autodesk.Viewing.theExtensionManager.registerExtension('ModomExtension', ModomExtension);
